import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-four-pipe',
  templateUrl: './four-pipe.component.html',
  styleUrls: ['./four-pipe.component.scss']
})
export class FourPipeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
